/* eslint indent: 0 */

import './embedded_video.less';

import Backbone from 'backbone';
import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';
import noop from 'lodash/noop';

import videojs from 'zoomforth_zfutils/video.js';

function _uniqueId(strn) {
  return strn + '-' + Math.floor(Math.random()*10000000);
}

  const EmbeddedVideo = Backbone.View.extend({
        
    initialize: function(options) {
      this.$container = $(options.container);
      this.youtubeId = options.youtubeId || null;
      this.mpeg4Source = options.mpeg4Source || null;
      this.mpeg4LowQualitySource = options.mpeg4LowQualitySource || null;
      this.subtitleTrack = options.subtitleTrack || null;
      this.posterImage = options.posterImage;
      this.autoplay = options.autoplay; 
      /*
        for iphones and other real mobile phones we want to allow the device to use its native controls
        because we are sure they are html5 (not flash) and because the version of video.js
        we are using doesn't handle them well enough.
      */
      this.shouldUseNativeControls = userAgentDetect.isMobile.isAnyRealDevice();
      this._type = this._calculateType();
      this.vjsObj = null;
      this._hasError = false;
      this._videoId = _uniqueId('embedded-video-id-');

      if (this._type == 'video') {
        this.embedVideo();
      } else if (this._type == 'youtube') {
        this.embedYoutube();
      }
    }, 
    
    embedVideo: function() {
      // Step 1 make html
      var $video;
      var $errorHtml;
      $video = this._makeVideoHtml();
      this.setElement($video);
      //step 2 append to container
      this.$container.html(this.$el);
      // step 3
      // make video js
      this._createVjsObj();
      
      if (this.vjsObj.error()){
      // most likely, flash does not exist!
        $errorHtml = $(['<div class="no-flash-error"><div class="error-message">',
          'For this browser, you must have Flash installed in order to play this video.</div></div>'].join(''));
        this._hasError = true;
        
        this.setElement($errorHtml);
        this.$container.html(this.$el); 
      }
    }, 
    
    embedYoutube: function() {
      var $video = this._makeYoutubeHtml();
      this.setElement($video);
      
      this.$container.html(this.$el);
      this.vjsObj = videojs(this._videoId, {
        techOrder: ['youtube'],
        enablePrivacyEnhancedMode: true
      }, noop);
    }, 
    
    isVjs: function() {
      return !!this.vjsObj;
    },
    
    getVjsObj: function() {
      return this.vjsObj;
    }, 
    
    getType: function() {
      return this._type;
    }, 
    
    remove: function() {
      if(this.vjsObj) {
        this.vjsObj.dispose();
        this.vjsObj = null;
      } else {
        this.$el.remove();
      } 
      EmbeddedVideo.__super__.remove.call(this);
    },
    
    _makeYoutubeHtml: function() {
      var $video = $(document.createElement('video'));
      var $subtitleTrack = $(document.createElement('track')); 
      var $ytSource = $(document.createElement('source'));
      $video.addClass('video-js vjs-default-skin vjs-big-play-centered');
      $video.attr({
        id : this._videoId,
        controls: 'true',
        preload: 'auto',
        poster: this.posterImage
      });
      $ytSource.attr({
        type: 'video/youtube',
        src: `https://www.youtube.com/watch?v=${this.youtubeId}`
      });
      $video.append($ytSource);
      // IDK why we need to be sngling iOS out here, theorteically we never even make it here on ios because we use an iframe instead? Maybe for ipads?
      if (this.autoplay && !userAgentDetect.isMobile.iOS()){
        $video.attr('autoplay', 'true');
      }
      if (this.subtitleTrack) {
        $subtitleTrack.attr({
          'kind': 'subtitles',
          'src': this.subtitleTrack,
          'srclang': 'en',
          'label': 'English'
        });
        $video.append($subtitleTrack);
      }
      
      return $video;
    },
    
    _makeVideoHtml: function() {
      var $video = $(document.createElement('video'));
      var $source = $(document.createElement('source'));
      var $lowQualitySource = $(document.createElement('source'));
      var $subtitleTrack = $(document.createElement('track'));
      $video.addClass('video-js vjs-default-skin vjs-big-play-centered');
      $video.attr({
        id : this._videoId,
        controls: 'true',
        preload: 'auto',
        width: '100%',
        height: '100%',
        poster: this.posterImage
      });
      // no autoplay for ie8, 9 because of an issue with video-js-resolutions, when it has been switched to 240p
      if(this.autoplay && !userAgentDetect.isMobile.iOS() && !userAgentDetect.isIE.lessThanTen()){
        $video.attr('autoplay', 'true');
      }  
      $source.attr({
        'src': this.mpeg4Source,
        'type': 'video/mp4',
        'label': '480p',
        'res': 480
      });
      $video.append($source);
      if (this.mpeg4LowQualitySource){
        $lowQualitySource.attr({
          'src': this.mpeg4LowQualitySource,
          'type': 'video/mp4',
          'label': '240p',
          'res': 240
        });
        $video.append($lowQualitySource);
      }
      if (this.subtitleTrack) {
        $subtitleTrack.attr({
          'kind': 'captions',
          'src': this.subtitleTrack,
          'srclang': 'en',
          'label': 'English'
        });
        $video.append($subtitleTrack);
      }
      
      return $video;
    },
    
    _createVjsObj: function() {
      var techOrder;
      // windows 7 with ie fails at html5.
    
      // turns out that https://lars.st0ne.at/blog/html5+video+in+IE11+-+size+does+matter
      // basically, anything in portrait mode fails in html5 and does not fall back to flash
      if (userAgentDetect.os.isWin7() && userAgentDetect.isIE.any()){
        techOrder = ['flash'];
      } else{
        techOrder = ['html5', 'flash'];
      }    

      this.vjsObj = videojs(this._videoId, {
        techOrder: techOrder,
        nativeControlsForTouch: this.shouldUseNativeControls,
        plugins: {
          videoJsResolutionSwitcher: this.mpeg4LowQualitySource ? { default: 480 }: false
        }
      }, noop);
      
      // we want mobile to be able to play/pause with a tap
      if (this.shouldUseNativeControls) {
        this.vjsObj.on('click', (e)=> {
          e.stopPropagation();
          e.preventDefault();
          if (this.vjsObj.paused()) {
            this.vjsObj.play();
          } else {
            this.vjsObj.pause();
          }
        });
      } 

      return this.vjsObj;
    },
    
    _calculateType: function() {
      if(this.youtubeId) {
        return 'youtube';
      } 
      return 'video';
      
    }, 
    
    play: function(){
      if(this.isVjs()){
        this.vjsObj.play();
      }
    },
    
    pause: function(){
      if(this.isVjs()){
        this.vjsObj.pause();
      }
    }
    
  });
  

export default EmbeddedVideo;
